module.exports = __webpack_public_path__ + "img/avatar5.172d5f82.png";